export const galleryItems = [
  {
    id: "g1",
    src: "https://storage.helloreaddy.io/project_files/c4f2c66c-1a08-4ed3-87f2-fa775eeabedc/9605c48e-f561-4841-9380-00bb818cccb8_compressed_genel_reklam.webp",
    title: "Salonumuz ve Uygulama Alanları",
    alt: "Fatma Angay Güzellik Salonu iç mekan ve uygulama alanları",
    span: "lg:col-span-2 lg:row-span-2",
  },
  {
    id: "g2",
    src: "https://storage.helloreaddy.io/project_files/c4f2c66c-1a08-4ed3-87f2-fa775eeabedc/bc2b92b2-6e6f-4155-bb8e-64d6610aa23f_compressed_tum_vucut1500.webp",
    title: "Tüm Vücut Lazer Epilasyon",
    alt: "Tüm vücut lazer epilasyon uygulaması sonbahar kampanyası",
    span: "",
  },
  {
    id: "g3",
    src: "https://storage.helloreaddy.io/project_files/c4f2c66c-1a08-4ed3-87f2-fa775eeabedc/b833c26a-ef8e-41ea-9dba-ca0bb2cbcf6c_compressed_profcb1000.webp",
    title: "Profesyonel Cilt Bakımları",
    alt: "Profesyonel cilt bakımı uygulaması, 1.000 TL kampanyası",
    span: "",
  },
  {
    id: "g4",
    src: "https://storage.helloreaddy.io/project_files/c4f2c66c-1a08-4ed3-87f2-fa775eeabedc/30670c26-910d-4fc3-bb9f-85fee523b7ec_compressed_3tekliflazer.webp",
    title: "Sonbahar Lazer Kampanyası",
    alt: "Sonbahar lazer epilasyon üç teklif kampanya görseli",
    span: "lg:col-span-2",
  },
  {
    id: "g5",
    src: "https://storage.helloreaddy.io/project_files/c4f2c66c-1a08-4ed3-87f2-fa775eeabedc/050fc2b5-d482-4ee5-8bc2-d34dcc737975_compressed_camcilt.webp",
    title: "Cam Cilt Bakımı",
    alt: "Cam cilt bakımı uygulaması ve bakım seçenekleri",
    span: "",
  },
  {
    id: "g6",
    src: "https://storage.helloreaddy.io/project_files/c4f2c66c-1a08-4ed3-87f2-fa775eeabedc/0c436b9b-8954-4d44-8a41-6c13b89185c1_compressed_tumcb1000.webp",
    title: "Kol, Bacak ve Koltuk Altı",
    alt: "Tüm kol, tüm bacak ve koltuk altı lazer epilasyon kampanyası",
    span: "",
  },
  {
    id: "g7",
    src: "https://storage.helloreaddy.io/project_files/c4f2c66c-1a08-4ed3-87f2-fa775eeabedc/b82c75b8-9007-436c-9b14-89dc793969f6_compressed_lekeakneodakli.webp",
    title: "Leke & Akne Odaklı Bakım",
    alt: "Leke ve akne odaklı cilt bakımı uygulaması",
    span: "",
  },
  {
    id: "g8",
    src: "https://storage.helloreaddy.io/project_files/c4f2c66c-1a08-4ed3-87f2-fa775eeabedc/751144a0-6dfe-4cab-bfbe-f4e9ea83724d_compressed_yuzbolgesi500.webp",
    title: "Yüz Bölgesi Lazer Epilasyon",
    alt: "Yüz bölgesi lazer epilasyon uygulaması 500 TL kampanyası",
    span: "",
  },
  {
    id: "g9",
    src: "https://storage.helloreaddy.io/project_files/c4f2c66c-1a08-4ed3-87f2-fa775eeabedc/441d5eb4-b0a6-4c26-9b65-da7a950fe386_compressed_100TLsonbaharkampanya.webp",
    title: "Sonbahar Cilt Bakımı Kampanyası",
    alt: "Sonbahar cilt bakımı kampanya görseli",
    span: "",
  },
  {
    id: "g10",
    src: "https://storage.helloreaddy.io/project_files/c4f2c66c-1a08-4ed3-87f2-fa775eeabedc/8648fc22-aa64-4ffe-9af3-75a484612326_compressed_logo.webp",
    title: "Fatma Angay Güzellik Salonu",
    alt: "Fatma Angay Güzellik Salonu logosu",
    span: "",
  },
];